var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import { dateType } from 'tss-core-lib-common';
import { css, StyleSheet } from 'aphrodite';
import Icon from 'react-svg-ikon';

import { IMG_ICON_CHEVRON_DOWN, IMG_ICON_CHEVRON_UP } from '../img';

import { IconButton } from './buttons';

var styles = void 0;

var numberRe = /^\d{1,2}$/;

var AmPmSelector = function AmPmSelector(_ref) {
  var isPM = _ref.isPM,
      onToggle = _ref.onToggle;
  return React.createElement(
    'span',
    { role: 'button', tabIndex: 0, className: css(styles.amPmSelectorContainer), onClick: onToggle },
    React.createElement(
      'span',
      { style: [styles.amPmLabel, !isPM && styles.amPmLabelSelected] },
      'AM'
    ),
    React.createElement(
      'span',
      null,
      '/'
    ),
    React.createElement(
      'span',
      { style: [styles.amPmLabel, isPM && styles.amPmLabelSelected] },
      'PM'
    )
  );
};

AmPmSelector.propTypes = {
  isPM: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired
};

var TimePicker = function (_Component) {
  _inherits(TimePicker, _Component);

  function TimePicker(props) {
    _classCallCheck(this, TimePicker);

    var _this = _possibleConstructorReturn(this, (TimePicker.__proto__ || Object.getPrototypeOf(TimePicker)).call(this, props));

    _initialiseProps.call(_this);

    var date = props.selectedDate ? props.selectedDate.tz(_this.props.timezone) : moment().utc().tz(_this.props.timezone).startOf('day');

    _this.state = {
      date: date,
      minutes: date.format('mm'),
      hours: date.format(props.h24 ? 'HH' : 'hh')
    };
    return _this;
  }

  _createClass(TimePicker, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var date = nextProps.selectedDate ? nextProps.selectedDate.tz(this.props.timezone) : moment().utc().tz(this.props.timezone).startOf('day');

      this.setState({
        date: date,
        minutes: date.format('mm'),
        hours: date.format(nextProps.h24 ? 'HH' : 'hh')
      });
    }
  }, {
    key: 'addDeltaTime',
    value: function addDeltaTime(delta) {
      var newDate = this.state.date.clone();
      if (delta.minutes) {
        newDate.add(delta.minutes, 'minutes');
      }
      if (delta.hours) {
        newDate.add(delta.hours, 'hours');
      }

      newDate = this.clampDate(newDate);

      this.setState({
        date: newDate,
        minutes: newDate.format('mm'),
        hours: newDate.format(this.props.h24 ? 'HH' : 'hh')
      }, this.updateDate);
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: css(styles.timePickerContainer) },
        React.createElement(
          'div',
          { className: css(styles.marginContainer) },
          !this.props.h24 ? React.createElement(AmPmSelector, { isPM: this.state.date.hours() > 11, onToggle: this.handleAmPmToggle }) : null
        ),
        React.createElement(
          'div',
          { className: css(styles.timeEntryContainer) },
          React.createElement(
            IconButton,
            { onClick: this.handleHourUp },
            React.createElement(Icon, { src: IMG_ICON_CHEVRON_UP, stroke: 'black' })
          ),
          React.createElement('input', {
            ref: this.setHourInputRef,
            value: this.state.hours,
            className: css(styles.timePickerInput),
            onFocus: this.handleFocus,
            onChange: this.handleHourChange,
            onBlur: this.handleInputBlur,
            onKeyDown: this.handleHoursKeyDown
          }),
          React.createElement(
            IconButton,
            { onClick: this.handleHourDown },
            React.createElement(Icon, { src: IMG_ICON_CHEVRON_DOWN, stroke: 'black' })
          )
        ),
        React.createElement(
          'span',
          { className: css(styles.divider) },
          ':'
        ),
        React.createElement(
          'div',
          { className: css(styles.timeEntryContainer) },
          React.createElement(
            IconButton,
            { onClick: this.handleMinuteUp },
            React.createElement(Icon, { src: IMG_ICON_CHEVRON_UP, stroke: 'black' })
          ),
          React.createElement('input', {
            ref: this.setMinuteInputRef,
            value: this.state.minutes,
            className: css(styles.timePickerInput),
            onFocus: this.handleFocus,
            onChange: this.handleMinuteChange,
            onBlur: this.handleInputBlur,
            onKeyDown: this.handleMinutesKeyDown
          }),
          React.createElement(
            IconButton,
            { onClick: this.handleMinuteDown },
            React.createElement(Icon, { src: IMG_ICON_CHEVRON_DOWN, stroke: 'black' })
          )
        ),
        React.createElement(
          'div',
          { className: css(styles.marginContainer) },
          this.props.timezoneString ? React.createElement(
            'div',
            { className: css(styles.timezoneDisplay) },
            this.props.timezoneString
          ) : React.createElement(
            'div',
            { className: css(styles.timezoneDisplay) },
            this.state.date.format('z')
          )
        )
      );
    }
  }]);

  return TimePicker;
}(Component);

TimePicker.propTypes = {
  selectedDate: dateType,
  min: dateType,
  max: dateType,
  h24: PropTypes.bool.isRequired,
  locale: PropTypes.string,
  timezone: PropTypes.string,
  timezoneString: PropTypes.string,
  onChange: PropTypes.func.isRequired
};
TimePicker.defaultProps = {
  selectedDate: null,
  min: null,
  max: null,
  locale: null,
  timezone: null,
  timezoneString: null
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.setMinuteInputRef = function (ref) {
    _this2.minuteInput = ref;
  };

  this.setHourInputRef = function (ref) {
    _this2.hourInput = ref;
  };

  this.updateDate = function () {
    var newDate = _this2.state.date.clone();
    if (_this2.props.min) {
      newDate = moment.max(_this2.props.min, newDate);
    }

    if (_this2.props.max) {
      newDate = moment.min(_this2.props.max, newDate);
    }

    _this2.props.onChange(newDate);
  };

  this.clampDate = function (date) {
    return date.clone();
  };

  this.handleMinutesKeyDown = function (event) {
    if (event.keyCode === 37 /* left arrow */ && _this2.minuteInput.selectionStart === _this2.minuteInput.selectionEnd && _this2.minuteInput.selectionStart === 0) {
      _this2.hourInput.select();
    } else if (event.keyCode === 38 /* up arrow */) {
        _this2.addDeltaTime({ minutes: 1 });
      } else if (event.keyCode === 40 /* down arrow */) {
        _this2.addDeltaTime({ minutes: -1 });
      }
  };

  this.handleHoursKeyDown = function (event) {
    if (event.keyCode === 39 /* right arrow */ && _this2.hourInput.selectionStart === _this2.hourInput.selectionEnd && _this2.hourInput.selectionStart === _this2.hourInput.value.length) {
      _this2.minuteInput.select();
    } else if (event.keyCode === 38 /* up arrow */) {
        _this2.addDeltaTime({ hours: 1 });
      } else if (event.keyCode === 40 /* down arrow */) {
        _this2.addDeltaTime({ hours: -1 });
      } else if (event.keyCode === 9 /* tab */) {
        _this2.minuteInput.focus();
        event.preventDefault();
      }
  };

  this.handleMinuteChange = function () {
    var value = _this2.minuteInput.value;
    if (value.match(numberRe)) {
      var minutes = parseInt(value, 10);
      var newDate = _this2.clampDate(_this2.state.date.clone().minutes(Math.max(0, Math.min(59, minutes))));
      var previousValue = _this2.state.minutes;
      _this2.setState({
        date: newDate,
        minutes: newDate.format('m')
      }, function () {
        if (value.length === 2 && previousValue.length === 1) {
          // Automatically skip to hours input
          setTimeout(function () {
            return _this2.hourInput.focus();
          }, 1);
        }
      });
    } else {
      _this2.setState({
        date: _this2.state.date.clone().minutes(0),
        minutes: ''
      });
    }
  };

  this.handleHourChange = function () {
    var value = _this2.hourInput.value;
    if (value.match(numberRe)) {
      var hours = parseInt(value, 10);
      if (!_this2.props.h24 && _this2.state.date.hours() > 11) {
        // PM
        hours += 12;
      }
      var newDate = _this2.clampDate(_this2.state.date.clone().hours(Math.max(0, Math.min(23, hours))));
      var previousValue = _this2.state.hours;
      _this2.setState({
        date: newDate,
        hours: _this2.props.h24 ? newDate.format('H') : value
      }, function () {
        if (value.length === 2 && previousValue.length === 1) {
          // Automatically skip to minutes input
          setTimeout(function () {
            return _this2.minuteInput.focus();
          }, 1);
        }
      });
    } else {
      _this2.setState({
        date: _this2.state.date.clone().hours(0),
        hours: ''
      });
    }
  };

  this.handleHourUp = function () {
    return _this2.addDeltaTime({ hours: 1 });
  };

  this.handleHourDown = function () {
    return _this2.addDeltaTime({ hours: -1 });
  };

  this.handleMinuteUp = function () {
    return _this2.addDeltaTime({ minutes: 1 });
  };

  this.handleMinuteDown = function () {
    return _this2.addDeltaTime({ minutes: -1 });
  };

  this.handleInputBlur = function () {
    _this2.setState({
      minutes: _this2.state.date.format('mm'),
      hours: _this2.state.date.format(_this2.props.h24 ? 'HH' : 'hh')
    });
    _this2.updateDate();
  };

  this.handleFocus = function (event) {
    return event.target.select();
  };

  this.handleAmPmToggle = function () {
    var newDate = void 0;
    if (_this2.state.date.hours() > 11) {
      // PM
      newDate = _this2.state.date.clone().hours(_this2.state.date.hours() - 12);
    } else {
      newDate = _this2.state.date.clone().hours(_this2.state.date.hours() + 12);
    }
    _this2.setState({
      date: newDate,
      minutes: newDate.format('mm'),
      hours: newDate.format(_this2.props.h24 ? 'HH' : 'hh')
    }, _this2.updateDate);
  };
};

styles = StyleSheet.create({
  timePickerContainer: {
    display: 'flex',
    justifyContent: 'center'
  },

  timeEntryContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },

  divider: {
    display: 'flex',
    alignItems: 'center'
  },

  timePickerInput: {
    width: '3rem',
    fontSize: '1.4rem',
    margin: '0.6rem',
    padding: 0,
    border: 0,
    outline: 0,
    textAlign: 'center'
  },

  marginContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  amPmSelectorContainer: {
    display: 'flex',
    fontSize: '1.2rem',
    cursor: 'pointer'
  },

  amPmLabel: {
    margin: '0 0.3rem',
    color: '#ccc'
  },

  amPmLabelSelected: {
    color: '#333'
  },

  timezoneDisplay: {
    fontSize: '1.2rem',
    color: '#333',
    border: '1px solid #bbb',
    padding: '0.5rem 0.5rem 0.4rem 0.5rem'
  }
});

export default TimePicker;